import React, { Component } from "react";
import { Form, Input } from "semantic-ui-react";
import _ from "lodash";
import InlineError from "../../messages/InlineError";
import settings from "../../../settings";

class SlideControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultData === undefined ? 0 : props.defaultData
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.defaultData === undefined ? 0 : nextProps.defaultData
    });
  }

  onChange = (e, data) => {
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
  };

  render() {
    const { control } = this.props;
    const color = control.FieldRequired ? "red" : "black";
    const controlRanges = _.filter(
      settings.controls,
      c => c.name === control.FieldName
    );
    let controlRange;
    if (controlRanges !== undefined && controlRanges.length > 0) {
      controlRange = controlRanges[0];
    }
    const controlDisplay = this.props.hideControl === true ? "none" : "block";
    return (
      <div style={{ display: controlDisplay }}>
        <Form.Field>
                <label htmlFor={control.FieldLabel} style={{ color }} className="padding-5">
            {`Search ${control.FieldLabel} : ${this.state.value} ${
              control.FieldOptionValues
            }`}
          </label>
          <Input
            id={control.FieldId}
            type="range"
            min={controlRange === undefined ? 0 : controlRange.minValue}
            max={controlRange === undefined ? 100 : controlRange.maxValue}
            step={controlRange === undefined ? 1 : controlRange.stepValue}
            name={control.FieldName}
            placeholder={control.FieldLabel}
            onChange={this.onChange}
            value={this.state.value}
          />
          {this.props.errors[control.FieldName] !== undefined &&
            this.props.errors[control.FieldName] !== "" && (
              <InlineError text={this.props.errors[control.FieldName]} />
            )}
        </Form.Field>
      </div>
    );
  }
}

export default SlideControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/SlideControl.js